import { render, staticRenderFns } from "./ProductDetailFullwidth.vue?vue&type=template&id=1a301cbe&scoped=true&lang=html"
import script from "./ProductDetailFullwidth.vue?vue&type=script&lang=js"
export * from "./ProductDetailFullwidth.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailFullwidth.vue?vue&type=style&index=0&id=1a301cbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a301cbe",
  null
  
)

export default component.exports